import React from 'react';

import _ from 'lodash';

import DatePicker from 'components/DatePicker';
import calendarIcon from './assets/calendar.svg';

import {DATE_FORMAT} from 'utils/datetime';

import './styles.css';

interface DateInputProps {
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  value?: string;
  onChange?: any;
  onBlur?: (e: any) => void;
  name?: string;
  dayPickerProps?: any;
  onDateChange?: (e: any) => void;
  overlayComponent?: any;
}

const DateInput = ({
  value,
  onChange,
  onBlur,
  name,
  placeholder,
  className,
  disabled,
  dayPickerProps,
  onDateChange,
  overlayComponent
}: DateInputProps) => (
  <div className="DateInput">
    <div className="inputWrapper">
      <div className="colab-centered icon">
        <img src={calendarIcon} alt="Calendar icon" />
      </div>
      <DatePicker
        className={className}
        placeholder={_.isNil(placeholder) ? DATE_FORMAT : placeholder}
        disabled={disabled}
        value={value}
        onChange={value => {
          onChange(value);
          onDateChange && onDateChange(value);
        }}
        onBlur={onBlur}
        name={name}
        dayPickerProps={dayPickerProps}
        overlayComponent={overlayComponent}
      />
    </div>
  </div>
);

export default DateInput;
